/** Session payload after survey-submit-tng so /tng can render the PIN overlay after navigation. */
export const TNG_REWARD_SESSION_KEY = 'ploomsurvey:tng_reward';

export type TngRewardSessionPayload = {
  pin: string;
  expirydate: string | null;
  value: string | null;
};

export function writeTngRewardSession(payload: TngRewardSessionPayload): void {
  try {
    sessionStorage.setItem(TNG_REWARD_SESSION_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function readTngRewardSession(): TngRewardSessionPayload | null {
  try {
    const raw = sessionStorage.getItem(TNG_REWARD_SESSION_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const pin = (o as { pin?: unknown }).pin;
    if (typeof pin !== 'string' || pin.length === 0) return null;
    const expirydate = (o as { expirydate?: unknown }).expirydate;
    const rawVal = (o as { value?: unknown }).value;
    return {
      pin,
      expirydate: typeof expirydate === 'string' ? expirydate : null,
      value: typeof rawVal === 'string' ? rawVal : null,
    };
  } catch {
    return null;
  }
}
